import React from 'react';
import { MdClear, MdOutlineWarning, MdAutoAwesome } from "react-icons/md";
import TextField from "@components/TextField";
import AutoCompleteField from "@components/AutoCompleteV2";
import { applyDiscount } from '@utils/format';

const ProductLines = ({ 
  lines, 
  doctype, 
  categories, 
  products,
  taxes, 
  warehouses, 
  automation,
  indif,
  idprovider,
  idposto,
  idordersource,
  handleChange, 
  removeFunction, 
  shouldAlert, 
  shouldAlertStockMin,
  openBarcodeModal,
  createFieldHandlers,
  calculateLineValues
}) => {
  
  // Função para truncar texto longo
  const truncateText = (text, maxLength = 25) => {
    if (!text) return 'N/A';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="products-section" style={{
      padding: '12px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      margin: '12px 0'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
        paddingBottom: '8px',
        borderBottom: '1px solid #e9ecef'
      }}>
        <h2 style={{
          margin: 0,
          fontSize: '18px',
          fontWeight: '600',
          color: '#2c3e50'
        }}>Linhas do Documento</h2>
        <span style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
          color: '#6c757d',
          backgroundColor: '#e9ecef',
          padding: '2px 8px',
          borderRadius: '12px'
        }}>
          {lines.length} {lines.length === 1 ? 'linha' : 'linhas'}
        </span>
      </div>
      
      {lines.map((line, key) => {
        const alertMessage = shouldAlert(line);
        const isAIGenerated = line._importedByAI === true;
        return (
          <div key={key} style={{
            backgroundColor: isAIGenerated ? '#f0f9ff' : '#ffffff',
            border: `1px solid ${alertMessage ? '#ffc107' : isAIGenerated ? '#7dd3fc' : '#e9ecef'}`,
            borderRadius: '6px',
            padding: '12px',
            marginBottom: '12px',
            boxShadow: isAIGenerated ? '0 2px 8px rgba(125, 211, 252, 0.3)' : '0 1px 4px rgba(0,0,0,0.06)',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}>
            {/* Header da linha */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '12px',
              paddingBottom: '8px',
              borderBottom: '1px solid #e9ecef'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <span style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  borderRadius: '50%',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                  fontWeight: '600'
                }}>
                  {key + 1}
                </span>
                <span style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#2c3e50'
                }}>
                  Linha {key + 1}
                </span>
                {/* Badge "Gerado por AI" */}
                {isAIGenerated && (
                  <div style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '10px',
                    fontSize: '10px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '3px',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                  }}>
                    <MdAutoAwesome size={12} />
                    Gerado por AI
                  </div>
                )}
              </div>
              
              <button
                type="button"
                onClick={() => removeFunction(key)}
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '4px 8px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '3px',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
              >
                <MdClear size={14} />
                Remover
              </button>
            </div>

            {/* Alerta se houver */}
            {alertMessage && (
              <div style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                padding: '6px 8px',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <MdOutlineWarning color="#856404" size={14} />
                <span style={{ color: '#856404', fontSize: '12px' }}>
                  {alertMessage}
                </span>
              </div>
            )}


            {/* Campos da linha */}
            <div className="product-line-fields" style={{
              padding: doctype.value === 'quotes' ? '8px' : '12px', 
              border: doctype.value === 'quotes' ? '1px solid #e9ecef' : '1px solid #e1e5e9', 
              borderRadius: doctype.value === 'quotes' ? '6px' : '8px',
              backgroundColor: '#ffffff',
              boxShadow: doctype.value === 'quotes' ? '0 1px 2px rgba(0,0,0,0.05)' : '0 2px 4px rgba(0,0,0,0.05)',
              marginBottom: '12px',
              transition: 'all 0.2s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ffffff';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = doctype.value === 'quotes' ? '0 1px 2px rgba(0,0,0,0.05)' : '0 2px 4px rgba(0,0,0,0.05)';
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: doctype.value === 'orders' || doctype.value === 'transfer'
                  ? 'repeat(auto-fit, minmax(90px, 1fr))'
                  : doctype.value === 'quotes'
                    ? '1fr auto'
                    : 'repeat(auto-fit, minmax(160px, 1fr))',
                gap: (doctype.value === 'orders' || doctype.value === 'transfer') ? '8px' : '12px'
              }} className={['returns', 'orders', 'transfer'].includes(doctype.value) ? 'product-lines-returns' : ''}>
          {(((doctype.condition && (doctype.condition === "automation.value == 'manual'" ? automation.value === 'manual' : doctype.condition === "!indif" ? !indif : true)) || !doctype.condition) ? doctype.lines : doctype.lines_alt).map((lineConf) => {
            switch (lineConf) {
              case 'category':
                return (
                  <div key={lineConf} className="product-field">
                    <AutoCompleteField
                      options={categories.filter(({value: categoryValue}) => {
                        // Para quotes no modo assistido, filtrar categorias já selecionadas
                        if (doctype.value === 'quotes' && automation.value === 'auto') {
                          const categoryAlreadyUsed = lines.some((otherLine, otherIndex) => {
                            // Não comparar com a própria linha
                            if (otherIndex === key) return false;
                            
                            // Verificar se a linha tem categoria válida
                            if (!otherLine.category || !otherLine.category.value) {
                              return false;
                            }
                            
                            // Comparar categoria
                            return otherLine.category.value === categoryValue;
                          });
                          
                          return !categoryAlreadyUsed;
                        }
                        
                        // Para outros casos, mostrar todas as categorias
                        return true;
                      })}
                      value={line.category}
                      onChange={(_, category) => {
                        handleChange({
                          target: {
                            name: `lines|${key}|category`,
                            value: category
                          }
                        });
                      }}
                      getOptionLabel={(option) => option.label || ""}
                      label="Família"
                      style={{
                        height: doctype.value === 'orders' ? '40px' : '36px'
                      }}
                    />
                    {line.category ? (line.products.length ? (
                      <div style={{ marginTop: '10px', width: '100%' }}>
                        {/* Desktop Table View */}
                        <div className="desktop-table-view" style={{ display: 'block' }}>
                          <div style={{ 
                            padding: doctype.value === 'quotes' ? '8px' : '12px', 
                            border: doctype.value === 'quotes' ? '1px solid #e9ecef' : '1px solid #e1e5e9', 
                            borderRadius: doctype.value === 'quotes' ? '6px' : '8px',
                            overflowX: 'auto',
                            backgroundColor: '#ffffff',
                            boxShadow: doctype.value === 'quotes' ? '0 1px 2px rgba(0,0,0,0.05)' : '0 2px 4px rgba(0,0,0,0.05)'
                          }}>
                            <table className="compact-products-table" id="tab_logic" style={{
                              minWidth: doctype.value === 'quotes' ? '600px' : '800px',
                              width: '100%',
                              fontSize: doctype.value === 'quotes' ? '12px' : '13px',
                              borderCollapse: 'separate',
                              borderSpacing: '0',
                              borderRadius: doctype.value === 'quotes' ? '4px' : '6px',
                              overflow: 'hidden'
                            }}>
                              <thead>
                                <tr style={{
                                  backgroundColor: doctype.value === 'quotes' ? '#f1f3f4' : '#f8f9fa',
                                  borderBottom: doctype.value === 'quotes' ? '1px solid #dee2e6' : '2px solid #dee2e6'
                                }}>
                                  <th style={{ 
                                    width: '25%',
                                    minWidth: '180px',
                                    padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                    textAlign: 'left',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Produto</th>
                                  <th style={{ 
                                    width: '8%',
                                    minWidth: '70px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Embalagem</th>
                                  <th style={{ 
                                    width: '12%',
                                    minWidth: '100px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Vendas nos dias DCE</th>
                                  <th style={{ 
                                    width: '10%',
                                    minWidth: '90px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Margem de erro (%)</th>
                                  <th style={{ 
                                    width: '8%',
                                    minWidth: '70px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Stock min</th>
                                  <th style={{ 
                                    width: '8%',
                                    minWidth: '70px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Stock (hoje)</th>
                                  <th style={{ 
                                    width: '10%',
                                    minWidth: '90px',
                                    padding: doctype.value === 'quotes' ? '6px 4px' : '8px 6px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    borderRight: '1px solid #dee2e6',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Stock (estimativa)</th>
                                  <th style={{ 
                                    width: '12%',
                                    minWidth: '100px',
                                    padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    color: '#2c3e50',
                                    fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                    height: doctype.value === 'quotes' ? '28px' : '32px',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                  }}>Quantidade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(line.products || []).map((product, key1) => (
                                  <React.Fragment key={key1}>
                                    <tr 
                                      style={{ 
                                        backgroundColor: shouldAlertStockMin(product) ? '#fff8e1' : '#ffffff',
                                        borderBottom: '1px solid #e0e0e0',
                                        transition: 'all 0.2s ease',
                                        cursor: 'pointer'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = shouldAlertStockMin(product) ? '#fff3c4' : '#f5f5f5';
                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = shouldAlertStockMin(product) ? '#fff8e1' : '#ffffff';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                      }}
                                    >
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        borderRight: '1px solid #e8eaed',
                                        verticalAlign: 'middle',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        textAlign: 'left'
                                      }}>
                                        <div style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'flex-start',
                                          justifyContent: 'center',
                                          gap: '2px',
                                          height: '100%'
                                        }}>
                                          <div style={{
                                            fontWeight: '600',
                                            color: '#2c3e50',
                                            fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                            lineHeight: '1.2',
                                            textAlign: 'left',
                                            minWidth: 'fit-content'
                                          }}>
                                            {product.nome}
                                          </div>
                                        </div>
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontWeight: '600',
                                        color: '#495057',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                      }}>
                                        {product.stock_box || 1}
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                        color: '#495057',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                        fontWeight: '500'
                                      }}>
                                        {product.day_stock && product.day_stock !== 'IDC' 
                                          ? `${(parseFloat(product.day_stock) * parseFloat(product.stock_dce)).toFixed(1)} (${parseFloat(product.day_stock).toFixed(1)}/dia)` 
                                          : '0'
                                        }
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontWeight: '600',
                                        color: '#495057',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                      }}>
                                        {product.stock_threshold}%
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontWeight: '600',
                                        color: '#495057',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                      }}>
                                        {product.stock_min}
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontWeight: '600',
                                        color: '#495057',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                      }}>
                                        {product.today_stock}
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        borderRight: '1px solid #e8eaed',
                                        fontWeight: '600',
                                        color: '#495057',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle',
                                      }}>
                                        {product.stock}
                                      </td>
                                      <td style={{
                                        padding: doctype.value === 'quotes' ? '6px 8px' : '8px 10px',
                                        textAlign: 'center',
                                        height: doctype.value === 'quotes' ? '32px' : '36px',
                                        verticalAlign: 'middle'
                                      }}>
                                        <div style={{
                                          backgroundColor: '#e1f5fe',
                                          border: '2px solid #81d4fa',
                                          borderRadius: '4px',
                                          padding: '3px',
                                          minWidth: '60px',
                                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                          <TextField
                                            type="number"
                                            value={product.quantity || ''}
                                            onChange={(e) => {
                                              handleChange({
                                                target: {
                                                  name: `lines|${key}|products|${key1}|quantity`,
                                                  value: e.target.value
                                                }
                                              });
                                            }}
                                            style={{
                                              width: '100%',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                                              fontWeight: '700',
                                              textAlign: 'center',
                                              backgroundColor: 'transparent',
                                              border: 'none',
                                              color: '#1565c0'
                                            }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                    {shouldAlertStockMin(product) && (
                                      <tr style={{ 
                                        backgroundColor: '#FBFBE8',
                                        borderBottom: '1px solid #e8eaed'
                                      }}>
                                        <td colSpan="8" style={{ 
                                          padding: '6px 10px',
                                          textAlign: 'left',
                                          borderTop: '1px solid #ffcc00',
                                          borderBottom: '1px solid #ffcc00',
                                          height: '24px'
                                        }}>
                                          <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            backgroundColor: '#FBFBE8',
                                            padding: '2px 6px',
                                            borderRadius: '3px',
                                            border: '1px solid #ffcc00',
                                            boxShadow: '0 1px 2px rgba(255,204,0,0.2)'
                                          }}>
                                            <MdOutlineWarning size={12} color="#ffcc00" />
                                            <span style={{ 
                                              color: '#182424',
                                              fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                              fontWeight: '600'
                                            }}>
                                              {shouldAlertStockMin(product)}
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Mobile Card View */}
                        <div className="mobile-card-view" style={{ display: 'none' }}>
                          {(line.products || []).map((product, key1) => (
                            <div 
                              key={key1} 
                              className={doctype.value === 'returns' ? 'returns-mobile-card' : ''}
                              style={{
                                backgroundColor: shouldAlertStockMin(product) ? '#FBFBE8' : (doctype.value === 'returns' ? 'transparent' : '#FFF'),
                                border: doctype.value === 'returns' ? 'none' : '1px solid #ddd',
                                borderRadius: doctype.value === 'returns' ? '0' : '6px',
                                padding: doctype.value === 'returns' ? '0' : '8px',
                                marginBottom: doctype.value === 'returns' ? '0' : '6px',
                                boxShadow: doctype.value === 'returns' ? 'none' : '0 1px 3px rgba(0,0,0,0.1)'
                              }}>
                              {/* Product Header */}
                              {doctype.value === 'returns' ? (
                                <div className="product-header">
                                  <div className="product-icon">
                                    {key1 + 1}
                                  </div>
                                  <div className="product-title" title={product.nome}>
                                    {truncateText(product.nome, 30)}
                                  </div>
                                  <button
                                    className="remove-button"
                                    onClick={() => removeFunction(key)}
                                    title="Remover produto"
                                  >
                                    <MdClear size={18} />
                                  </button>
                                </div>
                              ) : (
                                <div style={{
                                  marginBottom: '6px',
                                  paddingBottom: '6px',
                                  borderBottom: '1px solid #eee'
                                }}>
                                  <h4 style={{
                                    margin: '0 0 4px 0',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#333',
                                    lineHeight: '1.2'
                                  }}>
                                    {product.nome}
                                  </h4>
                                  {shouldAlertStockMin(product) && (
                                    <div style={{
                                      backgroundColor: '#fff3cd',
                                      border: '1px solid #ffeaa7',
                                      borderRadius: '4px',
                                      padding: '4px 6px',
                                      fontSize: '10px',
                                      color: '#856404',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      width: '100%',
                                      boxSizing: 'border-box'
                                    }}>
                                      <MdOutlineWarning size={12} />
                                      <span style={{ fontSize: '10px', fontWeight: '500' }}>{shouldAlertStockMin(product)}</span>
                                    </div>
                                  )}
                                </div>
                              )}

                              {/* Product Details Grid */}
                              {doctype.value === 'returns' ? (
                                <div style={{
                                  display: 'flex !important',
                                  flexDirection: 'column !important',
                                  gap: '8px',
                                  marginBottom: '16px',
                                  width: '100% !important',
                                  boxSizing: 'border-box',
                                  maxWidth: '100% !important',
                                  padding: '0',
                                  margin: '0'
                                }}>
                                  <div style={{
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: '12px',
                                    padding: '8px',
                                    width: '100% !important',
                                    maxWidth: '100% !important',
                                    boxSizing: 'border-box',
                                    overflow: 'hidden',
                                    flex: '0 0 100% !important'
                                  }}>
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      color: '#dc2626',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                      marginBottom: '6px',
                                      display: 'block'
                                    }}>Posto</span>
                                    <div style={{
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      color: '#374151',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis'
                                    }} title={line.idposto?.label || 'N/A'}>
                                      {truncateText(line.idposto?.label, 20)}
                                    </div>
                                  </div>
                                  <div style={{
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: '12px',
                                    padding: '8px',
                                    width: '100% !important',
                                    maxWidth: '100% !important',
                                    boxSizing: 'border-box',
                                    overflow: 'hidden',
                                    flex: '0 0 100% !important'
                                  }}>
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      color: '#dc2626',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                      marginBottom: '6px',
                                      display: 'block'
                                    }}>P. Unit (s/IVA)</span>
                                    <div style={{
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      color: '#374151',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis'
                                    }}>{line.costprice ? parseFloat(line.costprice).toFixed(3) : 'N/A'}</div>
                                  </div>
                                  <div style={{
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: '12px',
                                    padding: '8px',
                                    width: '100% !important',
                                    maxWidth: '100% !important',
                                    boxSizing: 'border-box',
                                    overflow: 'hidden',
                                    flex: '0 0 100% !important'
                                  }}>
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      color: '#dc2626',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                      marginBottom: '6px',
                                      display: 'block'
                                    }}>P. Unit (c/IVA)</span>
                                    <div style={{
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      color: '#374151',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis'
                                    }}>{line.costprice_civa ? parseFloat(line.costprice_civa).toFixed(3) : 'N/A'}</div>
                                  </div>
                                  <div style={{
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: '12px',
                                    padding: '8px',
                                    width: '100% !important',
                                    maxWidth: '100% !important',
                                    boxSizing: 'border-box',
                                    overflow: 'hidden',
                                    flex: '0 0 100% !important'
                                  }}>
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      color: '#dc2626',
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                      marginBottom: '6px',
                                      display: 'block'
                                    }}>PVP (c/IVA)</span>
                                    <div style={{
                                      fontSize: '12px',
                                      fontWeight: '600',
                                      color: '#374151',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: '100%',
                                      overflow: 'hidden',
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis'
                                    }}>{line.price ? parseFloat(line.price).toFixed(3) : 'N/A'}</div>
                                  </div>
                                </div>
                              ) : (
                                <div style={{
                                  display: 'grid',
                                  gridTemplateColumns: '1fr 1fr 1fr',
                                  gap: '6px',
                                  marginBottom: '10px'
                                }}>
                                {/* Primeira linha */}
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Qtd Emb.</div>
                                  <div style={{ color: '#6c757d', fontSize: '12px' }}>{product.stock_box || 1}</div>
                                </div>
                                
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Marg. Erro</div>
                                  <div style={{ color: '#6c757d', fontSize: '12px' }}>{product.stock_threshold}%</div>
                                </div>
                                
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Stock Min.</div>
                                  <div style={{ color: '#6c757d', fontSize: '12px' }}>{product.stock_min}</div>
                                </div>
                                
                                {/* Segunda linha */}
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Stock Hoje</div>
                                  <div style={{ color: '#6c757d', fontSize: '12px' }}>{product.today_stock}</div>
                                </div>
                                
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Stock Est.</div>
                                  <div style={{ color: '#6c757d', fontSize: '12px' }}>{product.stock}</div>
                                </div>
                                
                                <div style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '4px 6px',
                                  borderRadius: '3px',
                                  fontSize: '11px'
                                }}>
                                  <div style={{ fontWeight: '600', color: '#495057', marginBottom: '1px', fontSize: '10px' }}>Vendas DCE</div>
                                  <div style={{ color: '#6c757d', fontSize: '10px' }}>
                                    {product.day_stock && product.day_stock !== 'IDC' 
                                      ? `${(parseFloat(product.day_stock) * parseFloat(product.stock_dce)).toFixed(1)}` 
                                      : '0'
                                    }
                                  </div>
                                </div>
                              </div>
                              )}

                              {/* Quantity Input */}
                              {doctype.value === 'returns' ? (
                                <div style={{
                                  background: '#fef2f2',
                                  border: '1px solid #fecaca',
                                  borderRadius: '12px',
                                  padding: '8px',
                                  width: '100% !important',
                                  maxWidth: '100% !important',
                                  boxSizing: 'border-box',
                                  marginTop: '8px',
                                  flex: '0 0 100% !important'
                                }}>
                                  <span style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    color: '#dc2626',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    marginBottom: '6px',
                                    display: 'block'
                                  }}>Quantidade</span>
                                  <TextField
                                    type="number"
                                    value={product.quantity || ''}
                                    onChange={(e) => {
                                      handleChange({
                                        target: {
                                          name: `lines|${key}|products|${key1}|quantity`,
                                          value: e.target.value
                                        }
                                      });
                                    }}
                                    style={{
                                      width: '100%',
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      textAlign: 'center',
                                      height: '36px',
                                      minHeight: '36px',
                                      backgroundColor: '#ffffff',
                                      border: '1px solid #fecaca',
                                      borderRadius: '8px',
                                      boxSizing: 'border-box'
                                    }}
                                  />
                                </div>
                              ) : (
                                <div style={{
                                  backgroundColor: '#e3f2fd',
                                  border: '1px solid #2196f3',
                                  borderRadius: '2px',
                                  padding: '3px',
                                  textAlign: 'center',
                                  width: '100%'
                                }}>
                                  <label style={{
                                    display: 'block',
                                    fontSize: '8px',
                                    fontWeight: '600',
                                    color: '#1976d2',
                                    marginBottom: '2px'
                                  }}>
                                    Qtd
                                  </label>
                                  <TextField
                                    type="number"
                                    value={product.quantity || ''}
                                    onChange={(e) => {
                                      handleChange({
                                        target: {
                                          name: `lines|${key}|products|${key1}|quantity`,
                                          value: e.target.value
                                        }
                                      });
                                    }}
                                    style={{
                                      width: '100%',
                                      fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                                      fontWeight: '600',
                                      textAlign: 'center',
                                      height: '28px',
                                      minHeight: '28px'
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#FBFBE8' }}>
                        <MdOutlineWarning /> <span style={{ color: '#182424' }}>Nenhum produto para encomendar</span>
                      </div>
                    )) : null}
                  </div>
                );
              case 'product':
              case '#product':
                return (
                  <div key={lineConf} style={{
                    gridColumn: doctype.value === 'quotes' ? 'span 1' : (['orders', 'returns'].includes(doctype.value) ? 'span 2' : 'span 3')
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Produto *
                      </label>
                      {line.product && line.product.value ? (
                        <div style={{
                          padding: '8px',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #28a745',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'left',
                          gap: '6px',
                          minWidth: 0 // Permite que o flex item encolha
                        }}>
                          <span style={{
                            textAlign: 'left',
                            fontSize: '13px',
                            fontWeight: '500',
                            color: '#495057',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1 // Ocupa o espaço disponível
                          }}>
                            {line.product.label || line.product.nome || `Produto ID: ${line.product.value}`}
                          </span>
                        </div>
                      ) : (
                        // AutoComplete quando produto não está selecionado
                        <AutoCompleteField
                          options={products.filter(({inativo, value: productValue}) => {
                            // Filtrar produtos inativos
                            if (inativo === 't') return false;
                            
                            // Para quotes, filtrar apenas produtos já selecionados (sem considerar posto)
                            if (doctype.value === 'quotes') {
                              const productAlreadyUsed = lines.some((otherLine, otherIndex) => {
                                // Não comparar com a própria linha
                                if (otherIndex === key) return false;
                                
                                // Verificar se a linha tem produto válido
                                if (!otherLine.product || !otherLine.product.value) {
                                  return false;
                                }
                                
                                // Comparar apenas produto (quotes não têm posto)
                                return otherLine.product.value === productValue;
                              });
                              
                              return !productAlreadyUsed;
                            }
                            
                            // Para outros tipos, filtrar combinações de posto+produto que já existem nas outras linhas
                            const combinationAlreadyUsed = lines.some((otherLine, otherIndex) => {
                              // Não comparar com a própria linha
                              if (otherIndex === key) return false;
                              
                              // Verificar se a linha tem produto e posto válidos
                              if (!otherLine.product || !otherLine.product.value || !otherLine.idposto || !otherLine.idposto.value) {
                                return false;
                              }
                              
                              // Verificar se a linha atual tem posto definido
                              if (!line.idposto || !line.idposto.value) {
                                return false;
                              }
                              
                              // Comparar combinação de produto + posto
                              return otherLine.product.value === productValue && 
                                     otherLine.idposto.value === line.idposto.value;
                            });
                            
                            return !combinationAlreadyUsed;
                          })}
                          value={line.product}
                          readOnly={lineConf === '#product'}
                          onChange={lineConf === '#product' ? undefined : (_, product) => {
                            handleChange({
                              target: {
                                name: `lines|${key}|product`,
                                value: product
                              }
                            });
                          }}
                          getOptionLabel={(option) => option.label || ""}
                          searchableFields={['nome', 'barcodes', 'idproduct']}
                          label=""
                          style={{
                            height: doctype.value === 'orders' ? '40px' : '36px'
                          }}
                          noResultsAction={{
                            text: "Criar novo produto",
                            action: (inputValue) => {
                              // inputValue is passed from the AutoCompleteV2 component
                              if (inputValue && inputValue.trim()) {
                                openBarcodeModal(inputValue.trim(), key);
                              }
                            }
                          }}
                        />
                      )}
                    </div>
                  </div>
                );
              case 'quantity':
              case '#quantity':
                return doctype.value === 'quotes' ? (
                  <div key={lineConf} style={{
                    gridColumn: doctype.value === 'quotes' ? 'span 1' : 'span 2',
                    width: '100%',
                    maxWidth: '150px'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Quantidade *
                      </label>
                      <div style={{
                        backgroundColor: '#e1f5fe',
                        border: '2px solid #81d4fa',
                        borderRadius: '4px',
                        padding: '3px',
                        width: '100%',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                      }}>
                        <TextField
                          type="number"
                          min="0"
                          step="any"
                          label=""
                          readOnly={lineConf === '#quantity'}
                          {...(lineConf === '#quantity' ? {} : createFieldHandlers(key, 'quantity', line))}
                          style={{
                            width: '100%',
                            fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                            fontWeight: '700',
                            textAlign: 'center',
                            backgroundColor: 'transparent',
                            border: 'none',
                            color: '#1565c0',
                            height: doctype.value === 'orders' ? '34px' : '30px'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div key={lineConf} style={{
                    gridColumn: doctype.value === 'quotes' ? 'span 1' : 'span 1',
                    minWidth: '90px'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Quantidade *
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        step="any"
                        label=""
                        readOnly={lineConf === '#quantity'}
                        {...(lineConf === '#quantity' ? {} : createFieldHandlers(key, 'quantity', line))}
                        style={{
                          fontSize: '13px',
                          fontWeight: '500',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: '90px'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'costprice':
              case '#costprice':
                return (
                  <div key={lineConf} style={{
                    minWidth: doctype.value === 'orders' ? '90px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        P. Unit (s/IVA)
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        step="0.001"
                        label=""
                        value={line.costprice || ''}
                        readOnly={lineConf === '#costprice'}
                        {...(lineConf === '#costprice' ? {} : createFieldHandlers(key, 'costprice', line))}
                        style={{
                          fontSize: '13px',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: doctype.value === 'orders' ? '90px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'costprice_civa':
              case '#costprice_civa':
                return (
                  <div key={lineConf} style={{
                    minWidth: doctype.value === 'orders' ? '90px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        P. Unit (c/IVA)
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        step="0.001"
                        label=""
                        value={line.costprice_civa || ''}
                        readOnly={lineConf === '#costprice_civa'}
                        {...(lineConf === '#costprice_civa' ? {} : createFieldHandlers(key, 'costprice_civa', line))}
                        style={{
                          fontSize: '13px',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: doctype.value === 'orders' ? '90px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'total_siva':
              case '#total_siva':
                // Campo removido - agora editável na seção Resultado
                return null;
              case 'total_civa':
              case '#total_civa':
                // Campo removido - agora editável na seção Resultado
                return null;
              case 'pvp':
              case '#pvp':
                return (
                  <div key={lineConf} style={{
                    minWidth: doctype.value === 'orders' ? '90px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        PVP (c/IVA)
                      </label>
                      <TextField
                        type="text"
                        label=""
                        value={line.price || ''}
                        readOnly={lineConf === '#pvp'}
                        onChange={lineConf === '#pvp' ? undefined : (e) => {
                          handleChange({
                            target: {
                              name: `lines|${key}|price`,
                              value: e.target.value
                            }
                          });
                        }}
                        style={{
                          fontSize: '13px',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: doctype.value === 'orders' ? '90px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'lucro':
              case '#lucro':
                return (
                  <div key={lineConf} className="product-line-field-lucro" style={{
                    minWidth: doctype.value === 'orders' ? '80px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Lucro (%)
                      </label>
                      <div className="product-line-field-lucro-value" style={{
                        padding: '8px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '13px',
                        fontWeight: '500',
                        color: '#6c757d',
                        textAlign: 'right',
                        height: doctype.value === 'orders' ? '40px' : '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        width: doctype.value === 'orders' ? '80px' : 'auto'
                      }}>
                        {line.price && line.costprice_civa && line.iva ? 
                          (100 - (((applyDiscount(applyDiscount(line.costprice, line.desc1), line.desc2) - line.desc) * (1 + (line.iva.tax || 0)/100)) * 100 / line.price)).toFixed(2) + '%' : 
                          '0,00%'
                        }
                      </div>
                    </div>
                  </div>
                );
              case 'desc1':
              case '#desc1':
                return (
                  <div key={lineConf} style={{
                    minWidth: doctype.value === 'orders' ? '70px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Desc. 1 (%)
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        label=""
                        readOnly={lineConf === '#desc1'}
                        {...(lineConf === '#desc1' ? {} : createFieldHandlers(key, 'desc1', line))}
                        style={{
                          fontSize: '13px',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: doctype.value === 'orders' ? '70px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'desc2':
              case '#desc2':
                return (
                  <div key={lineConf} style={{
                    minWidth: doctype.value === 'orders' ? '70px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Desc. 2 (%)
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        label=""
                        readOnly={lineConf === '#desc2'}
                        {...(lineConf === '#desc2' ? {} : createFieldHandlers(key, 'desc2', line))}
                        style={{
                          fontSize: '13px',
                          height: doctype.value === 'orders' ? '40px' : '36px',
                          width: doctype.value === 'orders' ? '70px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'desc':
              case '#desc':
                return (
                  <React.Fragment key={lineConf}>
                    {/* Desc. € (s/IVA) */}
                    <div style={{
                      minWidth: doctype.value === 'orders' ? '90px' : 'auto'
                    }}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px'
                      }}>
                        <label style={{
                          fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                          fontWeight: '600',
                          color: '#495057',
                          margin: 0
                        }}>
                          Desc. € (s/IVA)
                        </label>
                        <TextField
                          type="number"
                          min="0"
                          step="0.001"
                          label=""
                          readOnly={lineConf === '#desc'}
                          {...(lineConf === '#desc' ? {} : createFieldHandlers(key, 'desc', line))}
                          style={{
                            fontSize: '13px',
                            height: doctype.value === 'orders' ? '40px' : '36px',
                            width: doctype.value === 'orders' ? '90px' : 'auto'
                          }}
                        />
                      </div>
                    </div>
                    {/* Desc. € (c/IVA) */}
                    <div style={{
                      minWidth: doctype.value === 'orders' ? '90px' : 'auto'
                    }}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px'
                      }}>
                        <label style={{
                          fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                          fontWeight: '600',
                          color: '#495057',
                          margin: 0
                        }}>
                          Desc. € (c/IVA)
                        </label>
                        <TextField
                          type="number"
                          min="0"
                          step="0.001"
                          label=""
                          readOnly={lineConf === '#desc'}
                          {...(lineConf === '#desc' ? {} : createFieldHandlers(key, 'desc_civa', line))}
                          style={{
                            fontSize: '13px',
                            height: doctype.value === 'orders' ? '40px' : '36px',
                            width: doctype.value === 'orders' ? '90px' : 'auto'
                          }}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                );
              case 'iva':
              case '#iva':
                return (
                  <div key={lineConf} style={{
                    minWidth: (doctype.value === 'orders' || doctype.value === 'transfer') ? '80px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        {doctype.value === 'transfer' ? 'IVA (Origem)' : 'IVA *'}
                      </label>
                      <AutoCompleteField
                        options={taxes}
                        value={line.iva}
                        readOnly={lineConf === '#iva'}
                        onChange={lineConf === '#iva' ? undefined : (_, iva) => {
                          handleChange({
                            target: {
                              name: `lines|${key}|iva`,
                              value: iva
                            }
                          });
                          
                          // Recalcular campos quando IVA muda
                          if (calculateLineValues) {
                            const calculatedValues = calculateLineValues(line, 'iva');
                            Object.keys(calculatedValues).forEach(fieldKey => {
                              if (calculatedValues[fieldKey] !== line[fieldKey] && calculatedValues[fieldKey] !== '') {
                                handleChange({
                                  target: {
                                    name: `lines|${key}|${fieldKey}`,
                                    value: calculatedValues[fieldKey]
                                  }
                                });
                              }
                            });
                          }
                        }}
                        getOptionLabel={(option) => option.label || ""}
                        label=""
                        style={{
                          height: (doctype.value === 'orders' || doctype.value === 'transfer') ? '40px' : '36px',
                          width: (doctype.value === 'orders' || doctype.value === 'transfer') ? '80px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'idposto':
              case '#idposto':
                return (
                  <div key={lineConf}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Posto
                      </label>
                      <AutoCompleteField
                        options={warehouses}
                        value={line.idposto}
                        readOnly={
                          lineConf === '#idposto' || 
                          (doctype.value === 'returns' && !indif)
                        }
                        onChange={
                          (lineConf === '#idposto' || 
                           (doctype.value === 'returns' && !indif)) 
                          ? undefined 
                          : (_, idposto) => {
                              handleChange({
                                target: {
                                  name: `lines|${key}|idposto`,
                                  value: idposto
                                }
                              });
                            }
                        }
                        getOptionLabel={(option) => option.label || ""}
                        label=""
                        style={{
                          height: doctype.value === 'orders' ? '40px' : '36px'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'idpostosource':
              case '#idpostosource':
                return (
                  <div key={lineConf}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Posto Origem
                      </label>
                      <AutoCompleteField
                        options={warehouses}
                        value={line.idpostosource}
                        readOnly={lineConf === '#idpostosource'}
                        onChange={(_, idpostosource) => {
                          handleChange({
                            target: {
                              name: `lines|${key}|idpostosource`,
                              value: idpostosource
                            }
                          });
                        }}
                        getOptionLabel={(option) => option.label || ""}
                        label=""
                        style={{
                          height: doctype.value === 'orders' ? '40px' : '36px'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'costprice_source':
              case '#costprice_source':
                return (
                  <div key={lineConf} style={{
                    minWidth: (doctype.value === 'orders' || doctype.value === 'transfer') ? '90px' : 'auto'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        P. Unit (Origem)
                      </label>
                      <TextField
                        type="number"
                        min="0"
                        step="0.001"
                        label=""
                        value={line.costprice_source || ''}
                        readOnly={lineConf === '#costprice_source'}
                        {...(lineConf === '#costprice_source' ? {} : createFieldHandlers(key, 'costprice_source', line))}
                        style={{
                          fontSize: '13px',
                          height: (doctype.value === 'orders' || doctype.value === 'transfer') ? '40px' : '36px',
                          width: (doctype.value === 'orders' || doctype.value === 'transfer') ? '90px' : 'auto'
                        }}
                      />
                    </div>
                  </div>
                );
              case 'last_costprice':
              case '#last_costprice':
                return (
                  <div key={lineConf}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      <label style={{
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        margin: 0
                      }}>
                        Últ. P. Custo
                      </label>
                      <div style={{
                        padding: '8px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ced4da',
                        borderRadius: '4px',
                        fontSize: '13px',
                        fontWeight: '500',
                        color: '#6c757d',
                        textAlign: 'right',
                        height: doctype.value === 'orders' ? '40px' : '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                      }}>
                        {line.last_costprice ? `€ ${parseFloat(line.last_costprice).toFixed(2)}` : '€ 0,00'}
                      </div>
                    </div>
                  </div>
                );
              default:
                return null;
            }
            })}
              </div>
            </div>

            {/* Seção de Totais - Resultado da Linha */}
            {doctype.value !== 'quotes' && (
              <div style={{
                marginTop: '12px',
                padding: '8px 12px',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#495057'
                }}>
                  Resultado:
                </span>
              
              {(doctype.value === 'transfer' || doctype.value === 'orders' || doctype.value === 'returns' || doctype.value === 'inventory') ? (
                /* Totais s/IVA e c/IVA - editável apenas para orders */
                <div className="resultado-container" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  flexWrap: 'wrap'
                }}>
                  {/* Total s/IVA - Editável apenas para orders */}
                  <div className="resultado-field" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <span style={{
                                        fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                      fontWeight: '500',
                      color: '#6c757d'
                    }}>
                      s/IVA:
                    </span>
                    {doctype.value === 'orders' ? (
                      <TextField
                        type="number"
                        min="0"
                        step="0.001"
                        value={line.total_siva || ''}
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: `lines|${key}|total_siva`,
                              value: e.target.value
                            }
                          });
                        }}
                        onBlur={(e) => {
                          if (calculateLineValues) {
                            const calculatedValues = calculateLineValues(line, 'total_siva');
                            Object.keys(calculatedValues).forEach(fieldKey => {
                              if (calculatedValues[fieldKey] !== line[fieldKey] && calculatedValues[fieldKey] !== '') {
                                handleChange({
                                  target: {
                                    name: `lines|${key}|${fieldKey}`,
                                    value: calculatedValues[fieldKey]
                                  }
                                });
                              }
                            });
                          }
                        }}
                        style={{
                          padding: '4px 8px',
                          backgroundColor: '#e9ecef',
                          border: '1px solid #ced4da',
                          borderRadius: '3px',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                          fontWeight: '600',
                          color: '#495057',
                          minWidth: '60px',
                          textAlign: 'center',
                          height: '28px'
                        }}
                      />
                    ) : (
                      <div style={{
                        padding: '4px 8px',
                        backgroundColor: '#e9ecef',
                        border: '1px solid #ced4da',
                        borderRadius: '3px',
                                              fontSize: doctype.value === 'quotes' ? '11px' : '12px',
                        fontWeight: '600',
                        color: '#495057',
                        minWidth: '60px',
                        textAlign: 'center',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {(() => {
                          if (doctype.value === 'transfer') {
                            const totalSiva = parseFloat(line.costprice_source || 0) * parseFloat(line.quantity || 0);
                            return `€ ${totalSiva.toFixed(2)}`;
                          }
                          if (doctype.value === 'returns' && Number(line.quantity || 0) === 0) {
                            return '€ 0,00';
                          }
                          return line.total_siva ? `€ ${parseFloat(line.total_siva).toFixed(2)}` : '€ 0,00';
                        })()}
                      </div>
                    )}
                  </div>

                  {/* Separador vertical compacto */}
                  <div className="resultado-separator" style={{
                    width: '1px',
                    height: '20px',
                    backgroundColor: '#dee2e6'
                  }}></div>

                  {/* Total c/IVA - Editável apenas para orders */}
                  <div className="resultado-field" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    <span style={{
                                        fontSize: doctype.value === 'quotes' ? '10px' : '11px',
                      fontWeight: '500',
                      color: '#6c757d'
                    }}>
                      c/IVA:
                    </span>
                    {doctype.value === 'orders' ? (
                      <TextField
                        type="number"
                        min="0"
                        step="0.001"
                        value={line.total_civa || ''}
                        onChange={(e) => {
                          handleChange({
                            target: {
                              name: `lines|${key}|total_civa`,
                              value: e.target.value
                            }
                          });
                        }}
                        onBlur={(e) => {
                          if (calculateLineValues) {
                            const calculatedValues = calculateLineValues(line, 'total_civa');
                            Object.keys(calculatedValues).forEach(fieldKey => {
                              if (calculatedValues[fieldKey] !== line[fieldKey] && calculatedValues[fieldKey] !== '') {
                                handleChange({
                                  target: {
                                    name: `lines|${key}|${fieldKey}`,
                                    value: calculatedValues[fieldKey]
                                  }
                                });
                              }
                            });
                          }
                        }}
                        style={{
                          padding: '4px 8px',
                          backgroundColor: '#d4edda',
                          border: '1px solid #28a745',
                          borderRadius: '3px',
                          fontSize: '13px',
                          fontWeight: '700',
                          color: '#155724',
                          minWidth: '60px',
                          textAlign: 'center',
                          height: '28px'
                        }}
                      />
                    ) : (
                      <div style={{
                        padding: '4px 8px',
                        backgroundColor: '#d4edda',
                        border: '1px solid #28a745',
                        borderRadius: '3px',
                        fontSize: '13px',
                        fontWeight: '700',
                        color: '#155724',
                        minWidth: '60px',
                        textAlign: 'center',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {(() => {
                          if (doctype.value === 'transfer') {
                            const totalSiva = parseFloat(line.costprice_source || 0) * parseFloat(line.quantity || 0);
                            const ivaTax = line.iva?.tax || 0;
                            const totalCiva = totalSiva * (1 + ivaTax / 100);
                            return `€ ${totalCiva.toFixed(2)}`;
                          }
                          if (doctype.value === 'returns' && Number(line.quantity || 0) === 0) {
                            return '€ 0,00';
                          }
                          return line.total_civa ? `€ ${parseFloat(line.total_civa).toFixed(2)}` : '€ 0,00';
                        })()}
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductLines;
